import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { AttendanceCustomTimeRangeDayEnum } from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import AddNewBlockWizard from '../Modals/AddNewBlockWizard'

interface HoverContentProps {
  dayType: AttendanceCustomTimeRangeDayEnum
  settingId: number
}

const HoverButton = ({ dayType, settingId }: HoverContentProps) => {
  const [isAddingNewBlock, setIsAddingNewBlock] = React.useState(false)

  return (
    <Box
      background="grey200"
      alignItems="center"
      justifyContent="center"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      height="full"
      width="full"
    >
      <Button type="secondary" onClick={() => setIsAddingNewBlock(true)} iconName="add">
        {i18n.t('common.add')}
      </Button>
      {isAddingNewBlock && (
        <AddNewBlockWizard
          settingId={settingId}
          dayType={dayType}
          onClose={() => setIsAddingNewBlock(false)}
        />
      )}
    </Box>
  )
}

export default HoverButton
